/**
 * @file lau-definition.ts
 * @module LauDefinition
 * @description Mapbox GL stilu slāņu definīcijas LAU (ceļu uzturēšanas transportlīdzekļiem)
 *              iegultajā kartē. Parāda transportlīdzekļu pozīcijas ar krāsu kodētām
 *              ikonām pēc transportlīdzekļa tipa un braukšanas virziena.
 */

import { LayerSpecification } from "maplibre-gl";

/** LAU maintenance vehicle point layer with always-visible icons */
export const LAU_POINT: LayerSpecification = {
	id: "lau-point",
	source: "lau",
	"source-layer": "public.lau_transportunit",
	type: "symbol",
	filter: ["all", ["==", ["geometry-type"], "Point"]],
	layout: {
		"icon-image": "c_lau",
		"icon-rotation-alignment": "viewport",
		"icon-size": 1,
		"icon-allow-overlap": true,
		"icon-ignore-placement": true,
	},
};
